import React from 'react';
import { Field } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import FacebookButton from '../../containers/facebook-button.container';
import FormField from '../form-field';

export default props => (
  <div className="row organizer-signin">
    <div className="col-6">
      <Field
        name="organizerEmail"
        label={
          <FormattedMessage
            id="organizerAuthentication.emailField.label"
            defaultMessage="Your email"
          />
        }
        type="email"
        subtext={emailSubtext(props)}
        component={FormField}
        onBlur={props.onEmailBlur}
        required
      />
    </div>
    <div className="col-6">
      {renderAuthenticationMethod(props)}
    </div>
  </div>
);

const emailSubtext = (props) => {
  if (props.method === 'guest') {
    return <FormattedMessage
      id="organizerAuthentication.emailField.subtext.guest"
      defaultMessage="Aha! You already have an account."
    />
  };
  return <FormattedMessage
    id="organizerAuthentication.emailField.subtext"
    defaultMessage="Receive confirmations here"
  />;
};

const renderFullName = () => (
  <Field
    name="organizerName"
    label={
      <FormattedMessage
        id="organizerAuthentication.nameField.label"
        defaultMessage="Your name"
      />
    }
    type="text"
    subtext={
      <FormattedMessage
        id="organizerAuthentication.nameField.subtext"
        defaultMessage="So invitees recognize you"
      />
    }
    component={FormField}
    required
  />
);

export const renderGuestLink = () => {
  return (
    <div className="form-group">
      <p className="pt-4">
        <sub className="small-print">
          <FormattedMessage
            id="organizerAuthentication.guestLink.previouslyCreatedGuest"
            defaultMessage="You previously created a guest account."
          />
          <br />
          <a href="/password-reset" target="_blank">
            <FormattedMessage
              id="organizerAuthentication.guestLink.forgotPassword"
              defaultMessage="Use forgot password"
            />
          </a>
          {' '}
          <FormattedMessage
            id="organizerAuthentication.guestLink.toSetNew"
            defaultMessage="to set a password then"
          />
          {' '}
          <a href="#reload"
            onClick={() => window.location.reload()}
          >
            <FormattedMessage
              id="organizerAuthentication.guestLink.reload"
              defaultMessage="reload this page"
            />
          </a>
          {' '}
          <FormattedMessage
            id="organizerAuthentication.guestLink.toSetNew2"
            defaultMessage="to create your group."
          />
        </sub>
      </p>
    </div>
  );
};

const renderAuthenticationMethod = (props) => {
  if (props.method === 'facebook') return renderFacebookAuthentication();
  if (props.method === 'signup') return renderFullName();
  if (props.method === 'guest') return renderGuestLink();
  return renderPasswordAuthentication(props);
};

const renderFacebookAuthentication = () => (
  <div className="small-print mt-4 pt-1">
    <FormattedMessage
      id="organizerAuthentication.facebook.alreadySignedWithFacebook"
      defaultMessage="You already signed up with Facebook previously."
    />
    <FormattedMessage
      id="organizerAuthentication.facebook.use"
      defaultMessage="Use"
    />
    {' '}
    <FacebookButton asLink>
      <FormattedMessage
        id="organizerAuthentication.facebook.connect"
        defaultMessage="Facebook Connect"
      />
    </FacebookButton>
    {' '}
    <FormattedMessage
      id="organizerAuthentication.facebook.toLogin"
      defaultMessage="to login."
    />
  </div>
);

const renderPasswordAuthentication = () => (
  <div>
    <small className="forgot-link">
      <a
        tabIndex="-1"
        href="/password-reset"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id="organizerAuthentication.password.forgot"
          defaultMessage="Forgot?"
        />
      </a>
    </small>
    <Field
      name="organizerPassword"
      label={
        <FormattedMessage
          id="organizerAuthentication.passwordField.label"
          defaultMessage="Your password"
        />
      }
      type="password"
      subtext={
        <FormattedMessage
          id="organizerAuthentication.passwordField.subtext"
          defaultMessage="Seems you already have an account"
        />
      }
      component={FormField}
      required
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-claim/organizer-authentication.js